/* Public Oath supplies store - Staples-style layout behaviour */
(function () {
  if (window.__poStore) return;
  window.__poStore = true;
  function $(s, r) { return (r || document).querySelector(s); }
  function $$(s, r) { return Array.prototype.slice.call((r || document).querySelectorAll(s)); }
  function store(k, v) {
    try {
      if (v === undefined) return window.localStorage.getItem(k);
      window.localStorage.setItem(k, v);
    } catch (e) { return null; }
  }
  var root = (window.Shopify && window.Shopify.routes && window.Shopify.routes.root) || '/';

  function initStrip() {
    $$('[data-po-strip]').forEach(function (strip) {
      var items = $$('.po-strip__item', strip);
      strip.classList.add('is-ready');
      if (!items.length) return;
      var i = 0;
      items[0].classList.add('is-active');
      if (items.length < 2) return;
      setInterval(function () {
        items[i].classList.remove('is-active');
        i = (i + 1) % items.length;
        items[i].classList.add('is-active');
      }, 4000);
    });
  }

  function initNav() {
    var nav = $('[data-po-nav]');
    if (!nav) return;
    var scroller = $('[data-po-scroller]', nav);
    var arrow = $('[data-po-nav-arrow]', nav);
    function upd() {
      if (!arrow || !scroller) return;
      arrow.hidden = scroller.scrollWidth - scroller.clientWidth - scroller.scrollLeft < 4;
    }
    if (arrow && scroller) {
      arrow.addEventListener('click', function () { scroller.scrollBy({ left: 260, behavior: 'smooth' }); });
      scroller.addEventListener('scroll', upd);
      window.addEventListener('resize', upd);
      upd();
    }
    var btns = $$('[data-po-panel-btn]', nav);
    function panelFor(b) { return document.getElementById(b.getAttribute('aria-controls')); }
    function closeAll(except) {
      btns.forEach(function (b) {
        if (b === except) return;
        b.setAttribute('aria-expanded', 'false');
        var p = panelFor(b);
        if (p) p.hidden = true;
      });
    }
    btns.forEach(function (b) {
      b.addEventListener('click', function (e) {
        e.stopPropagation();
        var open = b.getAttribute('aria-expanded') === 'true';
        closeAll(b);
        b.setAttribute('aria-expanded', open ? 'false' : 'true');
        var p = panelFor(b);
        if (p) p.hidden = open;
      });
    });
    document.addEventListener('click', function (e) { if (!e.target.closest('.po-panel')) closeAll(); });
    document.addEventListener('keydown', function (e) { if (e.key === 'Escape') closeAll(); });
  }

  function initNotice() {
    $$('[data-po-notice]').forEach(function (n) {
      var key = 'po_notice_' + (n.getAttribute('data-po-notice') || '');
      if (store(key) === '1') { n.hidden = true; return; }
      var c = $('[data-po-notice-close]', n);
      if (c) c.addEventListener('click', function () { n.hidden = true; store(key, '1'); });
    });
  }

  function initRows(scope) {
    $$('[data-po-row]', scope).forEach(function (row) {
      if (row.__po) return;
      row.__po = true;
      var list = $('[data-po-row-list]', row);
      var prev = $('[data-po-prev]', row);
      var next = $('[data-po-next]', row);
      if (!list) return;
      function step() {
        var first = list.firstElementChild;
        if (!first) return list.clientWidth;
        var w = first.getBoundingClientRect().width + 16;
        return w * Math.max(1, Math.floor(list.clientWidth / w));
      }
      function upd() {
        if (prev) prev.disabled = list.scrollLeft < 4;
        if (next) next.disabled = list.scrollWidth - list.clientWidth - list.scrollLeft < 4;
      }
      if (prev) prev.addEventListener('click', function () { list.scrollBy({ left: -step(), behavior: 'smooth' }); });
      if (next) next.addEventListener('click', function () { list.scrollBy({ left: step(), behavior: 'smooth' }); });
      list.addEventListener('scroll', upd);
      window.addEventListener('resize', upd);
      upd();
      setTimeout(upd, 600);
    });
  }

  var toastTimer;
  function toast(html) {
    var t = $('.po-toast');
    if (!t) {
      t = document.createElement('div');
      t.className = 'po-toast';
      t.setAttribute('role', 'status');
      document.body.appendChild(t);
    }
    t.innerHTML = html;
    t.classList.add('is-on');
    clearTimeout(toastTimer);
    toastTimer = setTimeout(function () { t.classList.remove('is-on'); }, 3500);
  }

  function initAdd() {
    document.addEventListener('submit', function (e) {
      var form = e.target && e.target.closest ? e.target.closest('[data-po-add]') : null;
      if (!form) return;
      e.preventDefault();
      var btn = form.querySelector('button[type=submit]');
      var label = btn ? btn.textContent : '';
      if (btn) { btn.disabled = true; btn.textContent = 'Adding...'; }
      fetch(root + 'cart/add.js', { method: 'POST', headers: { 'Accept': 'application/json' }, body: new FormData(form) })
        .then(function (r) { return r.json().then(function (j) { if (!r.ok) throw j; return j; }); })
        .then(function () { return fetch(root + 'cart.js', { headers: { 'Accept': 'application/json' } }).then(function (r) { return r.json(); }); })
        .then(function (cart) {
          $$('[data-po-cart-count]').forEach(function (el) { el.textContent = cart.item_count; });
          toast('Added to cart <a href="' + root + 'cart">View cart</a>');
          if (btn) {
            btn.textContent = 'Added';
            btn.classList.add('is-added');
            setTimeout(function () { btn.textContent = label; btn.classList.remove('is-added'); btn.disabled = false; }, 1800);
          }
        })
        .catch(function (err) {
          if (btn) { btn.textContent = label; btn.disabled = false; }
          toast((err && (err.description || err.message)) || 'Sorry, that could not be added to your cart.');
        });
    });
  }

  function initCollection() {
    var sort = $('[data-po-sort]');
    if (sort) {
      sort.addEventListener('change', function () {
        var u = new URL(window.location.href);
        u.searchParams.set('sort_by', sort.value);
        u.searchParams.delete('page');
        window.location.href = u.toString();
      });
    }
    var grid = $('[data-po-grid]');
    var views = $$('[data-po-view]');
    function setView(v) {
      if (!grid) return;
      grid.classList.toggle('is-list', v === 'list');
      views.forEach(function (b) {
        var on = b.getAttribute('data-po-view') === v;
        b.classList.toggle('is-active', on);
        b.setAttribute('aria-pressed', on ? 'true' : 'false');
      });
    }
    if (grid) {
      setView(store('po_view') || 'grid');
      views.forEach(function (b) {
        b.addEventListener('click', function () {
          var v = b.getAttribute('data-po-view');
          setView(v);
          store('po_view', v);
        });
      });
    }
    $$('[data-po-autosubmit] input[type=checkbox]').forEach(function (i) {
      i.addEventListener('change', function () { i.form.submit(); });
    });
    var pills = $$('.po-pill');
    pills.forEach(function (d) {
      d.addEventListener('toggle', function () {
        if (d.open) pills.forEach(function (o) { if (o !== d) o.open = false; });
      });
    });
    document.addEventListener('click', function (e) {
      if (!e.target.closest('.po-pill')) pills.forEach(function (d) { d.open = false; });
    });
    var drawer = $('[data-po-drawer]');
    if (drawer) {
      $$('[data-po-drawer-open]').forEach(function (b) {
        b.addEventListener('click', function () { drawer.hidden = false; document.documentElement.style.overflow = 'hidden'; });
      });
      $$('[data-po-drawer-close]', drawer).forEach(function (b) {
        b.addEventListener('click', function () { drawer.hidden = true; document.documentElement.style.overflow = ''; });
      });
    }
  }

  function init() { initStrip(); initNav(); initNotice(); initRows(document); initAdd(); initCollection(); }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', init);
  else init();
  document.addEventListener('shopify:section:load', function (e) { initRows(e.target); });
})();